import React from 'react';
import memoize from 'memoize-one';
import Actions from './Actions';

const Columns = memoize((clickHandler = () => {}) => [
  {
    name: 'RUT Y NOMBRE',
    cell: item => (
      <div className="d-flex flex-column" role="presentation" aria-hidden="true">
        <span className="text-muted" data-tag="allowRowEvents">
          {item?.employee?.national_identification}
        </span>
        <span className="text-truncate" data-tag="allowRowEvents">
          {item?.employee?.full_name}
        </span>
      </div>
    )
  },
  {
    name: 'Cargo',
    selector: 'job_title',
    sortable: false
  },
  {
    name: 'Simulación',
    selector: 'is_simulation'
  },
  {
    name: 'Fecha Término',
    selector: 'parsed_end_date',
    sortable: false,
    center: true
  },
  {
    name: 'Causal de Despido',
    selector: 'termination_reason',
    cell: item => item.termination_reason?.label,
    sortable: false,
    grow: 2
  },
  {
    name: 'Acciones',
    cell: item => <Actions item={item} handleClick={clickHandler} />,
    ignoreRowClick: true,
    center: true,
    button: true,
    minWidth: '140px'
  }
]);

export default Columns;
